<template>
  <div class="join">
    <Header />
    <Nav />
    <div class="join-container">
      <div class="join-banner">
        <img src="./../assets/icon/joinbanner.png" alt="" />
      </div>
      <div class="join-conts">
        <div class="join-contTitle">
          <p class="p1">
            讲师/机构入驻要求：<i>
              <img src="./../assets/icon/info.png" alt="" />
            </i>
            <span>在线咨询</span>
          </p>
          <p class="p2">
            <span
              >1、希望您是某高校的副教授及以上级别的老师或在某实验室担任技术负责人、质量负责人、授权签字人或在某金融公司从事金融行业数十年精英人才
            </span>
            <span
              >2、希望您在某一行业/领域具有丰富的检验检测行业从业工作经验</span
            >
          </p>
        </div>
        <div class="join-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>宏云课堂</el-breadcrumb-item>
            <el-breadcrumb-item>机构列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="join-contInput">
          <div class="join-leftbox">
            <h2>填写入驻表单</h2>
            <div class="box">
              <el-form
                :model="form"
                :rules="rules"
                ref="form"
                label-width="100px"
                class="demo-form"
              >
                <ul class="state-form">
                  <li>
                    <el-form-item label="姓名：" prop="name">
                      <el-input
                        v-model="form.name"
                        placeholder="请输入姓名"
                        minlength="108"
                      ></el-input>
                    </el-form-item>
                  </li>

                  <li>
                    <el-form-item label="联系方式：" prop="id">
                      <el-input
                        v-model="form.id"
                        placeholder="请输入联系方式"
                        minlength="108"
                      ></el-input>
                    </el-form-item>
                  </li>
                  <li>
                    <el-form-item label="电子邮箱：" prop="companyName">
                      <el-input
                        v-model="form.companyName"
                        placeholder="请输入电子邮箱"
                        minlength="108"
                      ></el-input>
                    </el-form-item>
                  </li>
                  <li>
                    <el-form-item label="职位：" prop="company">
                      <el-input
                        v-model="form.company"
                        placeholder="请输入职位"
                        minlength="108"
                      ></el-input>
                    </el-form-item>
                  </li>
                  <li>
                    <el-form-item label="单位：" prop="company">
                      <el-input
                        v-model="form.company"
                        placeholder="请输入单位"
                        minlength="108"
                      ></el-input>
                    </el-form-item>
                  </li>
                  <li>
                    <el-form-item label="删除授课内容：">
                      <el-input type="textarea" v-model="form.desc"></el-input>
                    </el-form-item>
                  </li>
                </ul>
              </el-form>
              <p class="btntext">*本人已确认以上信息真实有效</p>
              <div class="btns">
                <el-button type="primary" @click="submit('form')">提交</el-button>
              </div>
            </div>
          </div>
          <div class="join-rightbox">
            <div class="pages-online">
                    <div class="pages-online-title">
                        <img src="./../assets/icon/online.png" alt="">
                        <h4>在线咨询</h4>
                    </div>
                    <div class="pages-online-list">
                        <div class="pages-online-item">
                            <img src="./../assets/icon/ma.jpeg" class="ma" alt="">
                            <div class="pages-online-text">
                                <div class="pages-online-text-header"><h4>公众号</h4><img src="./../assets/icon/online-gzh.png" alt=""></div>
                                <p>使用微信【扫一扫】获取最新公告通知及最新功能预告</p>
                            </div>
                        </div>
                        <div class="pages-online-item">
                            <img src="./../assets/icon/ma1.jpeg" class="ma" alt="">
                            <div class="pages-online-text">
                                <div class="pages-online-text-header"><h4>微信指导</h4><img src="./../assets/icon/online-wx.png" alt=""></div>
                                <p>在线联系客服，获得1对1系统工具使用引导，快速了解现有及可扩展业务</p>
                            </div>
                        </div>
                        <div class="pages-online-last">
                            <img src="./../assets/icon/online-phone.png" alt="">
                            <span>联系电话：&nbsp;&nbsp; 13001143842</span>
                        </div>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from "../components/Fixed.vue";

export default {
  name: "Exam",
  components: {
    Header,
    Nav,
    Footer,
    Fixed
  },
  data() {
    return {
      form: {
        name: "",
        id: "",
        companyName: "",
        company: "",
        header_image: "",
        desc: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        isTop: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        id: [
          {
            required: true,
            message: "请输入身份证编码",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
        company: [
          {
            required: true,
            message: "请输入单位地址",
            trigger: "blur",
          },
        ],
        header_image: [
          {
            required: true,
            message: "请先上传文件",
            trigger: "submit",
          },
        ],
      },
    };
  },
};
</script>

<style lang="less" scoped>
.join {
  background-color: #f4f7f9;
  &-banner {
    width: 100%;
    height: 282px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-conts {
    width: 1300px;
    margin: 0 auto;
    position: relative;
    padding: 80px;
  }
  &-contTitle {
    width: 1170px;
    height: 155px;
    // box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    position: absolute;
    top: -77px;
    background: url("./../assets/icon/money.png") no-repeat;
    background-size: 100% 100%;
    padding: 14px 74px 0px 74px;
  }
  .p1 {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #202429;
    margin-top: 28px;
    i {
      width: 15px;
      display: inline-block;
      font-style: normal;
      position: relative;
    }
    img {
      width: 15px;
      height: 15px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-56%, -78%);
    }
    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666c80;
      line-height: 25px;
    }
  }
  .p2 {
    span {
      display: block;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
  }
  &-bread {
    margin: 20px 0px;
  }
  &-contInput{
    display: flex;
    justify-content: space-between;
  }
  &-leftbox {
    width: 877px;
    height: 717px;
    background: #ffffff;
    border-radius: 3px;
    border: 1px solid #eeeeee;
    h2 {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #202429;
      padding: 14px 28px;
      border-bottom: 1px solid #eeeeee;
    }
  }
  .box {
    width: 400px;
    margin-top: 20px;
    margin-left: 40px;
  }

  &-form {
    li {
      display: flex;
      align-items: center;
      padding: 10px 0;

      /deep/ .el-input {
        width: 400px;
      }

      /deep/ .el-textarea {
        width: 400px;
      }
    }

    &-title {
      width: 7em;
      text-align: right;
      padding-right: 6px;

      i {
        &::before {
          content: "*";
          color: #f00;
          position: relative;
          top: -3px;
          left: -2px;
          font-style: normal;
        }
      }
    }
    .el-form-item {
      margin-bottom: 0px;
    }
    /deep/.el-form-item__label {
      width: 108px !important;
    }
    .el-form-item__content {
      margin-left: 110px !important;
    }

    &-title2 {
      color: rgba(0, 0, 0, 0.65);
      line-height: 20px;
      padding: 0px;
      font-size: 14px;
      height: 20px;

      p {
        margin: 0px;
      }
    }

    &-content {
      //  flex: 1;
    }

    .el-input {
      width: 280px;
    }

    .el-upload--picture-card {
      width: 104px !important;
      height: 104px !important;
      line-height: 104px !important;
    }
    .el-upload-list--picture-card .el-upload-list__item {
      width: 104px !important;
      height: 104px !important;
    }
  }
  .btntext {
     font-size: 12px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: rgba(182, 20, 26, 0.64) !important;
     line-height: 17px;
     text-align: center;
     margin-top: 60px;
   }

   .btns {
     margin-top: 20px;
     text-align: center;
     padding-bottom: 80px;

     .el-button {
       width: 184px;
       height: 32px;
       background: linear-gradient(90deg, #FD441F 0%, #E1251B 100%);
       border-radius: 2px;
       border: 1px solid #E1251B;
       padding: 9px 20px;
     }
   }
   .pages-user {
        width: 408px;
        height: 153px;
        background: url(./../assets/icon/userBg.png) no-repeat;
        background-size: 100% 100%;
        padding: 22px 29px 15px 13px;
        box-sizing: border-box;
        position: relative;
        display: none;

        &-headimg {
            width: 60px;
            height: 60px;
        }

        &-msg {
            flex: 1;
            margin-left: 12px;
        }

        &-setting {
            width: 22px;
            height: 22px;
            position: absolute;
            top: 22px;
            right: 29px;
        }

        .top {
            display: flex;
            width: 100%;
            height: 60px;
            align-items: center;
            border-bottom: 1px solid rgba(208, 208, 208, 0.45);
            padding-bottom: 18px;

            p {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                color: #999999;
                line-height: 22px;
                margin: 0;

                b {
                    color: #202429;
                }
            }

            .label {
                display: inline-block;
                background: #FFF2F0;
                border-radius: 2px;
                border: 1px solid #FFCCC7;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF4D4F;
                line-height: 20px;
                padding-left: 2px;
                margin-top: 4px;

                &#companyType {
                    margin-left: 4px;
                    padding: 0 4px;
                }
            }
        }

        .bottom {
            display: flex;
            align-items: center;
            padding-top: 13px;

            img {
                width: 25px;
                height: 25px;
            }

            span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF6A4A;
                line-height: 20px;
                flex: 1;
                margin-left: 5px;

                i {
                    font-style: normal;
                    color: #202429;
                }
            }

            .btns {
                width: 70px;
                height: 22px;
                background: linear-gradient(180deg, #FF6A4A 0%, #FF6A4A 100%);
                border-radius: 11px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 22px;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .pages-online {
        width: 403px;
        height: 420px;
        margin-left: 2px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        margin-top: 17px;

        &-title {
            display: flex;
            height: 65px;
            align-items: center;
            background: url(./../assets/icon/onlineBg.png) no-repeat;
            background-size: 100% 100%;
            border-bottom: 1px solid #eee;

            img {
                width: 28px;
                height: 28px;
                margin-left: 12px;
            }

            h4 {
                flex: 1;
                font-size: 18px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #202429;
                line-height: 25px;
                margin-left: 15px;
            }
        }

        &-list {}

        &-item {
            border-bottom: 1px solid #EEEEEE;
            display: flex;
            margin: 0 12px;
            padding: 22px 0;

            .ma {
                width: 96px;
                height: 96px;
            }
        }

        &-text {
            margin-left: 20px;
            flex: 1;

            &-header {
                display: flex;
                align-items: center;

                h4 {
                    font-size: 18px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #202429;
                    line-height: 25px;
                    margin: 0;
                    margin-right: 4px;
                }

                img {
                    width: 18px;
                    height: 18px;
                }
            }

            p {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
            }
        }

        &-last {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #595959;
            line-height: 20px;
            padding-left: 20px;
            height: 74px;

            img {
                width: 20px;
                height: 22px;
                margin-right: 13px;
            }
        }
    }
}
</style>